import React, { useCallback, useMemo, useState } from 'react';
import './style.scss';

function AutoHeightCollapse({
  header,
  body,
  startCollapsed,
}: {
  header: (open: boolean, toggle: () => void) => React.ReactNode;
  body: React.ReactNode;
  startCollapsed?: boolean;
}) {
  const [collapsed, setCollapsed] = useState(startCollapsed ?? true);

  const toggle = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const headerComponent = useMemo(() => header(!collapsed, toggle), [header, toggle, collapsed]);

  return (
    <div className="auto-height-collapse" data-collapsed={collapsed}>
      <div className="collapse-header">{headerComponent}</div>
      <div className="collapse-body">{body}</div>
    </div>
  );
}

export default AutoHeightCollapse;
